var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostpaidSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9993 22.4128C16.9824 22.4128 21.8327 17.5625 21.8327 11.5794C21.8327 5.59634 16.9824 0.746094 10.9993 0.746094C5.01626 0.746094 0.166016 5.59634 0.166016 11.5794C0.166016 17.5625 5.01626 22.4128 10.9993 22.4128ZM12.0827 7.24609C12.0827 6.64779 11.5977 6.16276 10.9993 6.16276C10.401 6.16276 9.91601 6.64779 9.91601 7.24609V11.5794C9.91601 11.8667 10.0302 12.1423 10.2333 12.3455L12.9417 15.0538C13.3647 15.4768 14.0507 15.4768 14.4737 15.0538C14.8967 14.6307 14.8967 13.9448 14.4737 13.5217L12.0827 11.1307V7.24609Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpaidSelectedIcon);
export default __webpack_public_path__ + "static/media/postpaid-selected-icon.bd82e0d92c54a97b35f16b00a23af199.svg";
export { ForwardRef as ReactComponent };